import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/Account/authenticate',
    method: 'post',
    data,
  })
}

export function getInfo() {
  return request({
    url: '/Account/getInfo',
    method: 'get',
  })
}
// export function getInfo(token) {
//   return request({
//     url: '/Account/getInfo',
//     method: 'get',
//     params: { token }
//   })
// }

export function logout(data) {
  return request({
    url: '/Account/logout',
    method: 'post',
    data,
  })
}

export function getMemberPwd(query) {
  return request({
    url: '/Account/getMemberPwd',
    method: 'get',
    params: query,
  })
}
